import { render, staticRenderFns } from "./tab-confirm.vue?vue&type=template&id=426687f8&"
import script from "./tab-confirm.vue?vue&type=script&lang=js&"
export * from "./tab-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports